
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(2.5 2.5)"}},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7","stroke":"#ff27a3"}}),_c('path',{attrs:{"fill":"#ff27a3","d":"M7.5 4a.5.5 0 01.5.5v4a.5.5 0 01-1 0v-4a.5.5 0 01.5-.5zm0 6a.5.5 0 110 1 .5.5 0 010-1z"}})])])
      }
    
      }
    